import styled, { css } from 'styled-components';

const cssArrow = css`
  content: '';
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  top: 5px;
  width: 6px;
  height: 6px;
  border-style: solid;
  border-width: 2px 2px 0 0;
  border-color: ${({ theme }) => theme.palette.grayscale300};
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
`;

export const SelectDateButton = styled.button`
  position: relative;
  padding-right: 16px;
  color: ${({ theme }) => theme.palette.grayscale300};
  ${({ theme }) => theme.typography('$body_01')};

  &::after {
    ${cssArrow}
    width: 4px;
    height: 4px;
    top: 9px;
    border-width: 1px 1px 0 0;
    transform: rotate(135deg);
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0 4px;
  position: relative;
  right: -4px;
`;

export const ButtonPrev = styled.button`
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  position: relative;

  &::after {
    ${cssArrow}
    right: 7px;
    top: 8px;
    transform: rotate(-135deg);
  }
`;

export const ButtonNext = styled(ButtonPrev)`
  &::after {
    right: 9px;
    transform: rotate(45deg);
  }
`;
